import React, { useState, useEffect, useMemo } from 'react';
import { debounce, isEmpty, sortBy } from 'lodash';
import Badge from '../v2/Badge';
import AutoCompleteSearch from './autocomplete-search';
const CustomerTypeLabel = ({ userType }) => {
    let color = 'grey';
    if (userType === 'Shipper') {
        color = 'green';
    }
    else if (userType === 'Carrier') {
        color = 'blue';
    }
    else if (userType === 'Driver') {
        color = 'blue';
    }
    return React.createElement(Badge, { color: color }, userType);
};
const renderCustomer = (customer, label) => {
    return (React.createElement("a", { key: customer._id, id: customer._id, className: "list-group-item cursor-pointer" },
        React.createElement("div", { className: "flex" },
            React.createElement("div", { style: { minWidth: 80 } },
                React.createElement(CustomerTypeLabel, { userType: customer._type })),
            React.createElement("span", { className: "form-label px-2" }, label),
            customer.is_broker && (React.createElement("div", { style: { minWidth: 80 } },
                React.createElement(Badge, { color: "orange" }, "Broker"))))));
};
/*
 * An autocomplete component for searching customers
 */
export default function CustomerSearchFilter({ searchCustomers, searchField, placeholder, onSelect, clearOnSelect, }) {
    const [query, setQuery] = useState({});
    const [customers, setCustomers] = useState([]);
    function onSearch(nGram) {
        setQuery(Object.assign(Object.assign({}, query), { [searchField]: nGram }));
    }
    function getItemValue(item) {
        return item[searchField];
    }
    const debouncedQuery = useMemo(() => {
        return debounce(async (query) => {
            const customers = await searchCustomers(query);
            setCustomers(sortBy(customers, searchField));
        }, 350);
    }, []);
    useEffect(() => {
        if (!isEmpty(query)) {
            debouncedQuery(query, searchField);
        }
    }, [query]);
    return (React.createElement("div", null,
        React.createElement(AutoCompleteSearch, { onSearch: onSearch, onSelect: onSelect, items: customers, placeholder: placeholder, renderItem: (item) => renderCustomer(item, item[searchField]), clearOnSelect: clearOnSelect, getItemValue: getItemValue })));
}
